import styled from "styled-components";
import Radio from "@mui/material/Radio";

export const RadioStyled = styled(Radio)`

`;
